<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading" />
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card>
        <div slot="header">
          <h3 class="card-title mb-0">Datos básicos</h3>
        </div>
        <div class="columns">
          <div class="column">
            <CompanySelector v-model="companyId" :is-disable="!!subscriberId" />
          </div>
          <div class="column">
            <b-field label="Identificación *">
              <div class="control-content">
                <UserAutocomplete
                  name="entity"
                  v-model="entity"
                  placeholder="Buscar tercero..."
                  @onSearch="findEntity"
                />
              </div>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Nombres *">
              <b-input
                placeholder="Nombres"
                type="text"
                v-model="entity.name"
                readonly="readonly"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Total *">
              <b-input
                placeholder="Total"
                type="text"
                name="fullName"
                v-model="total"
                readonly="readonly"
                icon="currency-usd"
              />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="columns">
              <div class="column">
                <b-field label="Tipo de servicio *">
                  <b-select
                    placeholder="Seleccione un servicio"
                    expanded
                    v-model="serviceType"
                    name="serviceType"
                  >
                    <option
                      v-for="option in serviceTypeList"
                      :key="option.code"
                      :value="option"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="col-3">
                <b-button
                  @click="addService"
                  type="is-info"
                  style="margin-top: 44px"
                >
                  Agregar servicio</b-button
                >
              </div>
            </div>
          </div>
          <div class="column text-right">
            <b-button
              v-if="subscriberId"
              @click="confirmDeleteMonthly"
              style="margin-top: 30px; margin-right: 10px"
              type="is-danger"
            >
              Eliminar abonado
            </b-button>
            <b-button @click="save" type="is-success" style="margin-top: 30px">
              Guardar abonado
            </b-button>
          </div>
        </div>
      </vs-card>
      <vs-card v-if="serviceList && serviceList.length > 0">
        <div :key="forceRender">
          <vs-tabs>
            <vs-tab
              :label="service.serviceType.title"
              v-for="(service, index) in serviceList"
              :key="index"
            >
              <parking-service
                :company-id="Number.parseInt(companyId)"
                :service="setDefaultPeriodicity(service)"
                :show-multiparking="showMultiparking"
                :show-multi-slot="showMultiSlot"
                :show-plate-restriction="hasPlateRestriction"
                @deleteService="deleteService"
                @updateTotal="updateTotal"
              />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>
import UserAutocomplete from '@/components/Shared/Autocomplete/Users.vue'
import CompanySelector from '@/components/Shared/CompanySelector'
import ParkingService from '@/views/income-special/subscriber/services/ParkingService.vue'
import unityEndpoint from '@/endpoints/core/UnityEndpoint'
import settingsEndPoint from '@/endpoints/core/SettingsEndpoint'
import entityEndpoint from '@/endpoints/core/EntityEndpoint'
import incomeSpecialEndpoint from '@/endpoints/billing/IncomeSpecialEndpoint'
import kind from '@/global/lasting/EKind'
import toast from '@/global/ToastConfig'
import DateUtils from '@/global/DateUtils'

export default {
  name: 'subscriber',
  components: {
    CompanySelector,
    UserAutocomplete,
    ParkingService,
  },
  props: ['subscriberId'],
  data() {
    return {
      isLoading: false,
      showMultiparking: false,
      hasPlateRestriction: false,
      companyId: null,
      serviceTypeList: [],
      serviceType: null,
      entity: { code: null, name: '' },
      total: 0,
      serviceList: [],
      vehicleTypeList: [],
      forceRender: 0,
      showMultiSlot: false,
    }
  },
  mounted() {
    this.initQueries()

    if (this.subscriberId) {
      this.initForm()
    }
  },
  watch: {
    companyId(newValue, oldValue) {
      this.getCompanySettings()

      if (oldValue && !this.subscriberId) {
        this.serviceList = []
      }
    },
  },
  methods: {
    initForm() {
      incomeSpecialEndpoint.findById(this.subscriberId).then((info) => {
        if (!info) {
          return
        }
        this.companyId = info.company.code
        this.entity = info.entity
        const serviceList = info.serviceList
        serviceList.forEach((item, index) => {
          item.position = index
          item.initialDate = this.parserDate(item.initialDate)
          item.finalDate = this.parserDate(item.finalDate)
          if (item.itemList) {
            item.itemList.forEach((list, index) => (list.position = index))
          }
        })
        this.serviceList = serviceList
        this.total = info.total
        this.getUnityByTypeVehicle()
        this.forceRender++
      })
    },
    initQueries() {
      // Se consultan los tipos de servicio
      unityEndpoint
        .getUnityListByKind(kind.MONTHLY_SERVICE_TYPE, 'servicios')
        .then((info) => (this.serviceTypeList = info))

      this.getCompanySettings()
    },
    getCompanySettings() {
      if (!this.companyId) {
        return
      }

      settingsEndPoint
        .getCompanyExtraParams({ companyCode: this.companyId })
        .then(({ info }) => {
          this.showMultiparking = !!info.isMultiparking
          this.hasPlateRestriction = !!info.restrictedDriving
          this.showMultiSlot = !!info.isMultiSlot
        })
        .catch((error) => {
          console.error('Error al obtener parámetros de empresa:', error)
          this.showMultiparking = false
          this.hasPlateRestriction = false
          this.showMultiSlot = false
        })
    },
    async getUnityByTypeVehicle() {
      const vehicleTypeList = await unityEndpoint.getUnityListByKind(
        kind.VEHICLE_TYPE
      )
      this.validateInformationVehicleClassification(vehicleTypeList)
    },
    validateInformationVehicleClassification(vehicleTypeList) {
      this.serviceList.forEach((item) => {
        item.itemList.forEach((subItem) => {
          const isData =
            subItem.info &&
            subItem.info.vehicle &&
            subItem.info.vehicle.classification
          if (!isData) return
          const classificationInitial =
            subItem.info.vehicle.classification.initials
          // Buscar el objeto correspondiente en la lista 'info'
          const matchingInfo = vehicleTypeList.find(
            (infoItem) => infoItem.initials === classificationInitial
          )
          // Si se encuentra una coincidencia, completar la información
          if (matchingInfo)
            subItem.info.vehicle.classification = { ...matchingInfo }
        })
      })
    },
    findEntity({ action, searchQuery, callback }) {
      if (action !== 'ASYNC_SEARCH') {
        return
      }
      entityEndpoint
        .findByNameOrIdentificationAutocomplete(searchQuery)
        .then((info) => callback(null, info))
    },
    addService() {
      try {
        this.validateAddService()
        const service = {
          title: this.serviceType.title,
          serviceType: this.serviceType,
          itemList: [],
          position: this.serviceList.length,
          incomeType: null,
          initialDate: null,
          finalDate: null,
          liquidation: null,
          total: 0,
          slot: null,
          schedule: null,
          isPartial: 'NO',
          tariff : null,
          listTariff: [], // ← Nueva propiedad para lista de tarifas
        }
        this.serviceList.push(service)
        this.serviceType = null
      } catch (ex) {
        toast.error(ex.message)
      }
    },
    validateAddService() {
      if (!this.companyId) {
        throw new Error('Debe seleccionar una empresa')
      }
      if (!this.entity) {
        throw new Error('Debe seleccionar un tercero')
      }
      if (!this.serviceType) {
        throw new Error('Debe seleccionar un servicio')
      }
    },
    deleteService(service) {
      this.serviceList.splice(service.position, 1)
      this.serviceList.forEach((item, index) => (item.position = index))
      this.forceRender++
      this.updateTotal()
    },
    updateTotal() {
      let total = 0
      this.serviceList.forEach((item) => (total += parseInt(item.total)))
      this.total = total
    },
    confirmDeleteMonthly() {
      toast.ask(this, '¿Está seguro de eliminar el abonado?').then((result) => {
        if (!result) {
          return
        }
        this.isLoading = true
        incomeSpecialEndpoint
          .deleteIncome(this.subscriberId)
          .then((resultCode) => {
            this.isLoading = false
            if (resultCode > 0) {
              toast.ok('Se eliminó el abonado correctamente')
              this.validateResponse()
              return
            }
            toast.error('Error al eliminar el abonado')
          })
      })
    },
    validateResponse() {
      if (this.subscriberId) {
        this.$router.push({ name: 'LISTAR ABONADOS' })
        return
      }
      this.clearData()
    },
    save() {
      try {
        this.validateSave()
        this.isLoading = true
        const subscriber = {
          code: this.subscriberId,
          company: { code: this.companyId },
          total: this.total,
          serviceList: this.serviceList,
          entity: { code: this.entity.code },
        }
        incomeSpecialEndpoint.save(subscriber).then((resultCode) => {
          if (resultCode > 0) {
            this.validateResponse()
          }
          this.isLoading = false
        })
      } catch (ex) {
        toast.error(ex.message)
      }
    },
    validateSave() {
      if (!this.serviceList || this.serviceList.length === 0) {
        throw new Error('Debe agregar al menos un servicio')
      }
      this.serviceList.forEach((service) => {
        const title = service.title
        if (!service.incomeType) {
          throw new Error(
            'Debe seleccionar el tipo de mensual para el servicio: ' + title
          )
        }
        if (!service.initialDate) {
          throw new Error(
            'Debe seleccionar la fecha inicial para el servicio: ' + title
          )
        }
        if (!service.finalDate) {
          throw new Error(
            'Debe seleccionar la fecha final para el servicio: ' + title
          )
        }
        if (!service.liquidation) {
          throw new Error(
            'Debe seleccionar una liquidación para el servicio:' + title
          )
        }
        if (!service.schedule) {
          throw new Error(
            'Debe seleccionar el horario para el servicio: ' + title
          )
        }
        if (!service.quota || service.quota === 0) {
          throw new Error(
            'Debe ingresar la cantidad de cupos para el servicio: ' + title
          )
        }
        if (!service.slot) {
          throw new Error('Debe seleccionar un lote para el servicio: ' + title)
        }
        if (!service.itemList || service.itemList.length === 0) {
          throw new Error(
            'Debe agregar al menos un vehículo, artículo para el servicio: ' +
              title
          )
        }
        if (!service.periodicity) {
          throw new Error(
            'debe seleccionar una periodicidad para el servicio:' + title
          )
        }
      })
    },
    parserDate(a) {
      return DateUtils.parse({ date: a, timezone: '' }).toDate()
    },
    clearData() {
      this.companyId = null
      this.serviceList = []
      this.serviceType = null
      this.entity = { code: null, name: '' }
      this.forceRender++
      this.total = 0
    },
    /**
     * Envia  periodicidad mensual por defecto
     * @param objService
     * @returns {{periodicity}|*}
     */
    setDefaultPeriodicity(objService) {
      if (!objService.hasOwnProperty('periodicity')) {
        // Si la propiedad no existe, añadirla al objeto
        objService.periodicity = 'MONTHLY'
        return objService
      }
      return objService
    },
  },
}
</script>

<style scoped></style>
